module.exports = __webpack_public_path__ + "static/media/Ally_web_1.8230637d.jpg";